import { render, staticRenderFns } from "./Demension.vue?vue&type=template&id=d6925f22&scoped=true&"
import script from "./Demension.vue?vue&type=script&lang=js&"
export * from "./Demension.vue?vue&type=script&lang=js&"
import style0 from "./Demension.vue?vue&type=style&index=0&id=d6925f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6925f22",
  null
  
)

export default component.exports